import React, { useEffect, useState } from 'react'
import ButtonClose from '../../atoms/button-close/button-close'
import './modalTerms.scss'
import { getTerms } from './termsData'
import Loader from 'react-loader-spinner'
import { requestConcourseDates } from '../../../utils/useActivityDates'

///////////

const ModalTerms = ({ close }) => {
  const [ready, setReady] = useState(false)
  const [termsList, setTermsList] = useState([])

  const handlerClose = () => {
    if (close) {
      close()
      return
    }
  }

  useEffect(() => {
    //TAGEO OPEN MODAL TERMS
    requestConcourseDates()
      .then(() => {
        return getTerms()
      })
      .then(terms => {
        setTermsList(terms)
        setReady(true)
      })
  }, [])

  return (
    <div className="f-modal-terms">
      <ButtonClose
        onClick={handlerClose}
        title="cerrar modal y regresar al home"
      />
      <article className="f-modal-terms__container">
        <h2 className="f-modal-terms__title">Términos y Condiciones</h2>
        {!ready ? (
          <div className="flex margin-top-100">
            <Loader type="Oval" color="#EB0954" height={64} width={64} />
          </div>
        ) : null}
        <ul>
          {termsList.map((item, index) => {
            return <li key={'terms-' + index}>{item}</li>
          })}
        </ul>
      </article>
    </div>
  )
}

export default ModalTerms
